"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "m19.07 9.37.71-.71c.39-.39.39-1.02 0-1.41a.996.996 0 0 0-1.41 0l-.71.71c-.39.39-.39 1.02 0 1.41.38.39 1.02.39 1.41 0M21 18H3c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1M12 7c.56 0 1-.45 1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v1c0 .55.45 1 1 1M4.96 9.34c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41l-.71-.71a.996.996 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41zM19 16c0-3.87-3.13-7-7-7s-7 3.13-7 7z"
}), 'WbTwilightRounded');